// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAW6N06y56bVltYy4EVo9Qxg63uRRC-38Q",
  authDomain: "box-office-boffo.firebaseapp.com",
  projectId: "box-office-boffo",
  storageBucket: "box-office-boffo.appspot.com",
  messagingSenderId: "223141360184",
  appId: "1:223141360184:web:35b32ae93ab82eb2d56ccd"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

export default firebase;